<div class="w-100 float-left">
    <div class="w-100 float-left v-align relative b-b">
        <h5 class="medium float-left" *ngIf="type == 'ADD'"> {{'createUserGroup' | translate}} </h5>
        <h5 class="medium float-left" *ngIf="type == 'EDIT'"> {{'editGroup' | translate}} </h5>
        <div style="flex-grow: 1;"></div>
        <button class="btn btn-secondary float-right mb-2" (click)="goToBackPage()"><i
                class="fa fa-arrow-left mr-sm-2"></i> {{'back' | translate}}
        </button>
    </div>
    <div class="w-50 float-left mt-3">
        <form action="">
            <div class="form-group">
                <label> {{'name' | translate}}
                    <span class="text-danger medium">*</span>
                </label>
                <input type="text" class="form-control" [(ngModel)]="userGroupdata.name" name="name" maxlength="200"/>
                <span class="info-text"> ({{'Max' | translate}}. 200 {{'character' | translate}})</span>
            </div>

            <div class="form-group">
                <label> {{'description' | translate}}
                    <span class="text-danger medium"></span>
                </label>
                <textarea class="form-control" rows="5" [(ngModel)]="userGroupdata.description"
                          name="description"></textarea>
            </div>
        </form>
    </div>

    <div class="col-lg-3 col-md-3">
        <button class="btn btn-primary float-right" *ngIf="type == 'ADD'" (click)="editOrSave()"
                [disabled]="buttonDisabled">{{'create' | translate}}
        </button>
        <button class="btn btn-primary float-right" *ngIf="type == 'EDIT'" (click)="editOrSave()"
                [disabled]="buttonDisabled">{{'Update' | translate}}
        </button>
        <button class="btn btn-secondary float-right mr-4" (click)="goToBackPage()">{{'cancel' | translate}}</button>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/tools/userGroup/addUserGroup.html